module.exports = __webpack_public_path__ + "media/4x3/lk-497ee5b9.svg";